"use client";
import { Space } from "antd";
import { FC } from "react";
import { FaStar, FaStarHalfAlt } from "react-icons/fa";
import "./RatingStars.css";

interface RatingStarsProps {
  value: number; // امتیاز (مثلاً 3.5 یا 4)
  max?: number; // پیش‌فرض 5
  size?: number; // سایز آیکن
}
const RatingStars: FC<RatingStarsProps> = ({ value, max = 5, size = 18 }) => {
  const full = Math.floor(value);
  const hasHalf = value - full >= 0.5;

  return (
    <Space className="rating" size={4}>
      {Array.from({ length: max }).map((_, i) => {
        if (i < full) {
          return <FaStar key={i} size={size} className="filled" />;
        }
        if (i === full && hasHalf) {
          return (
            <FaStarHalfAlt
              key={i}
              size={size}
              className="filled star-half-rtl"
            />
          );
        }
        return <FaStar key={i} size={size} />;
      })}
    </Space>
  );
};

export default RatingStars;
